import { type FC } from 'react';
import styles from './AudioPlayer.module.scss';
import { type AudioPlayerPropTypes } from './types/propsType';
import { AudioPlayerType } from './types/enums';

const AudioPlayer: FC<AudioPlayerPropTypes> = ({ srcList, trackConfig, ...restProps }: AudioPlayerPropTypes) => (
  <audio controls className={styles['audio-player-container']} {...restProps} data-testid="audioplayer-testid">
    {srcList.map((audio, index) => (
      <source key={audio.id ?? `${audio.src}+${index}`} {...audio} />
    ))}
    <track kind="captions" {...trackConfig} data-testid="track-testid" />
    Your browser does not support the audio element.
  </audio>
);

AudioPlayer.displayName = 'AudioPlayer';
export type { AudioPlayerPropTypes };
export { AudioPlayerType };
export default AudioPlayer;
